import type Combatant from "@/encounter/model/Combatant.ts";
import type {Visibility} from "@/tabletop/visibility/VisibilityModel.ts";
import {pointInTokenSight} from "@/tabletop/visibility/TokenPerception.ts";

export function playerTokenVisibility(combatant: Combatant, visibility?: Visibility) {
    const outsideSight = Boolean(visibility?.enabled && combatant.hostile
        && !pointInTokenSight(combatant.position, visibility));
    const hidden = combatant.hidden;
    return {hidden, outsideSight, visible: !hidden && !outsideSight};
}
